/* Registrations.js */

"use strict";
module.exports = {
    LOGIN_CENTER_SECTION: "App.GameConsole.Section.LoginCenter",
    LOGOUT_CENTER_SECTION: "App.GameConsole.Section.LogoutCenter",
    EULA_SECTION: "App.GameConsole.Section.Eula",
    BANNER_SECTION: "App.GameConsole.Section.Banner",
    FAIL_COMMS_SECTION: "App.GameConsole.Section.FailComms",
    PASSWORD_RESET_SECTION: "App.GameConsole.Section.PasswordReset",
    SOLUTION_SWITCHER_SECTION: "App.GameConsole.Section.SolutionSwitcher",
};
Object.freeze(module.exports);
